import { gql } from '@apollo/client'

export const TRANSCRIBE_UTTERANCE = gql`
  mutation transcribeUtterance($id: ID!, $audio: Upload!) {
    transcribeUtterance(id: $id, audio: $audio) {
      id
      text
    }
  }
`
